import { serverUrl, getheader, setErrorDialog, translateError, getMethodByCallBack, cacheTypes, postMethodByCallBack, postMethodByDispatcher, getMethodByDispatcher } from "../../../store/api/CommonFunctions";
export function getInvoiceNewNumber(invoiceType, isFormal, onGetData) {
    onGetData("PENDING");
    fetch(serverUrl + `api/InvoiceAPI/GetInvoiceNewNumber?invoiceType=${invoiceType}&isFormal=${isFormal}`, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => onGetData(res))
        .catch(e => console.log("[GetInvoiceNewNumber]", e));
}
export function addEditInvoice(data, onDone) {
    return dispatch => {
        fetch(serverUrl + `api/InvoiceAPI/AddEditInvoice`, {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(data)
        }).then(res => res.json())
            .then(res => {
                setErrorDialog(dispatch, res.Message, "ثبت فاکتور");
                if (res.Invoice && Number(res.Invoice.InvoiceID) > 0) {
                    onDone(res);
                }
                else {
                    onDone({ Invoice: data });
                }
            })
            .catch(e => {
                setErrorDialog(dispatch, e.message, "ثبت فاکتور");
                onDone({ Invoice: data });
                console.log("[ADD_EDIT_INVOICE]", e);
            })
    }
}
export function getInvoiceStates(onGetData) {
    onGetData("PENDING");
    fetch(serverUrl + "api/InvoiceAPI/GetInvoiceStates", {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = null;
            }
            onGetData(res);
        })
}
export function searchInvoices(data) {
    return dispatch => {
        dispatch({
            type: "SEARCH_INVOICE",
            data: "PENDING"
        });
        dispatch({
            type: "INVOICE_SEARCH_FILTERS",
            data: data
        });

        fetch(serverUrl + "api/InvoiceAPI/SearchInvoice", {
            headers: getheader(),
            method: "POST",
            body: JSON.stringify(data)
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "جستجوی فاکتور");
                    res = null;
                }
                dispatch({
                    type: "SEARCH_INVOICE",
                    data: res
                })
            }).catch(e => {
                if (e.message) {
                    setErrorDialog(dispatch, e.message, "جستجوی فاکتور");
                }
                console.log("[SEARCH_INVOICE]", e);
                return dispatch({
                    type: "SEARCH_INVOICE",
                    data: null
                })
            })
    }
}
export function searchCustomerInvoices(data, onSearch) {

    postMethodByCallBack("api/InvoiceAPI/SearchInvoice", data, onSearch, "SearchInvoice");
}
export function getInvoice(invoiceID, invoiceType, onGetData) {
    onGetData("PENDING");
    fetch(serverUrl + `api/InvoiceAPI/GetInvoice?invoiceID=${invoiceID}&invoiceType=${invoiceType}`, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = { Error: translateError(res.Message) }
            }
            onGetData(res);
        }).catch(e => {
            console.log("[GET_INVOICE]", e);
            onGetData({ Error: "دریافت اطلاعات با مشکل مواجه شد" });
        })
}
export function getSMSInvoice(invoiceNumber, durationID, mobile, serverUrl, onGetData) {
    onGetData("PENDING");
    var myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Data-Type', 'json');

    fetch(`${serverUrl.replace(":::", "://")}/api/InvoiceAPI/GetSMSInvoice?invoiceNumber=${invoiceNumber}&durationID=${durationID}&mobile=${mobile}`, {
        headers: myHeaders,
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = { Error: translateError(res.Message) }
            }
            onGetData(res);
        }).catch(e => {
            console.log("[GET_SMS_INVOICE]", e);
            onGetData({ Error: "دریافت اطلاعات با مشکل مواجه شد" });
        })
}
export function deleteInvoice(invoiceID, invoiceType, onDelete) {
    return dispatch => {
        fetch(serverUrl + `api/InvoiceAPI/DeleteInvoice?invoiceID=${invoiceID}&invoiceType=${invoiceType}`, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                setErrorDialog(dispatch, res.Message, "حذف فاکتور");
                onDelete(res.Result);
            }).catch(e => {
                setErrorDialog(dispatch, "error", "حذف فاکتور");
                console.log("DELETE_INVOICE", e);
                onDelete(false);
            })
    }
}
export function convertPrecustomerProdutsToPreSale(preCustomerID, customerID, storageID, onSuccess) {
    return dispatch => {
        fetch(serverUrl + `api/InvoiceAPI/ConvertPrecustomerProdutsToPreSale?preCustomerID=${preCustomerID}&customerID=${customerID}&storageID=${storageID}`, {
            headers: getheader(),
            method: "get",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (!res.InvoiceID) {
                    setErrorDialog(dispatch, "error", "ثبت پیش فاکتور فروش");
                    return;
                }
                setErrorDialog(dispatch, res.Message, "ثبت پیش فاکتور فروش");
                if (Number(res.InvoiceID) > 0) {
                    onSuccess(res.InvoiceID);
                }
            }).catch(e => {
                console.log("[CONVERT_TO_PRESALE]", e);
                setErrorDialog(dispatch, e.message, "ثبت پیش فاکتور فروش");
            })
    }
}
export function salesReportByMonthOrYear(monthly, persianYear, onGetData) {

    onGetData("PENDING");
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (!token || !sUrl) {
        onGetData([]);
        return;
    }
    fetch(sUrl + `api/InvoiceAPI/SalesReportByMonthOrYear?monthly=${monthly}&persianYear=${persianYear}`, {
        headers: { "Token": token },
        method: "GET",
        cache: "default"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                onGetData({ Error: translateError(res.Message) });
            }
            else {
                onGetData(res);
            }
        })
}
export function salesCountByCreator(durationID, onGetData) {
    getMethodByCallBack(`api/InvoiceAPI/SalesCountByCreator?durationID=${durationID}`, cacheTypes.NoCache, onGetData, "SALES_COUNT_BY_CREATOR");
}
export function getSoldProductsList(durationID, onGetData) {
    getMethodByCallBack(`api/InvoiceAPI/SoldProductsList?durationID=${durationID}`, cacheTypes.NoCache, onGetData, "SOLD_PRODUCTS");
}
export function loadSaleIndexPage(durationID, persianYear, onGetData) {
    getMethodByCallBack(`api/InvoiceAPI/LoadSaleIndexPage?durationID=${durationID}&persianYear=${persianYear}`, cacheTypes.NoCache, onGetData, "LOAD_SALE_INDEX");
}
export function getSystemSettings(data, onGet) {
    return dispatch => {
        dispatch(postMethodByDispatcher("api/SystemSetting/GetSystemSettings", data, "GET_SYSTEM_SETTINGS", "تنظیمات سیستم", onGet))
    }
}
export function sendInvoiceSMS(invoiceID, onGetData) {
    getMethodByCallBack(`api/InvoiceAPI/SendInvoiceSMS?invoiceID=${invoiceID}`, cacheTypes.NoCache, onGetData, "SEND_INVOICE_SMS");
}
export function getDefaultStoragesInfo() {
    return dispatch => dispatch(getMethodByDispatcher(`api/StorageAPI/GetDefaultStorageInfo`, "DEFAULT_STORAGES", cacheTypes.NoCache, "انبارهای پیش فرض"));
}
export function getDetailCount(detailID, onGet) {
    getMethodByCallBack(`api/InvoiceAPI/GetDetailCount?detailID=${detailID}`, cacheTypes.NoCache, onGet, "GetDetailCount");
}
export function searchTaxPayerInvoice(data, isSent, onGet) {
    return dispatch => {
        dispatch({
            type: "TAXPAYER_SEARCH_FILTERS",
            data: data
        })
        dispatch(postMethodByDispatcher(`api/InvoiceAPI/SearchTaxPayerInvoice?isSent=${isSent}`, data, "SEARCH_TAXPAYER_INVOICE", "جستجوی فاکتور", onGet));
    }
}
export function sendInvoiceToTaxOffice(invoiceID, invoiceType, cancelInvoice, sendCustomerInfo, onDone) {
    getMethodByCallBack(`api/InvoiceAPI/SendInvoiceToTaxOffice?invoiceID=${invoiceID}&invoiceType=${invoiceType}&cancelInvoice=${cancelInvoice}&sendCustomerInfo=${sendCustomerInfo}`, cacheTypes.NoCache, onDone, "SendInvoiceToTaxOffice")
}
export function taxPayerInvoiceInquiry(invoiceID, onDone) {
    getMethodByCallBack(`api/InvoiceAPI/TaxPayerInvoiceInquiry?invoiceID=${invoiceID}`, cacheTypes.NoCache, onDone, "TaxPayerInvoiceInquiry");
}
export function getPrvNextInvoiceID(currentID, invoiceType, next, onGet) {
    getMethodByCallBack(`api/InvoiceAPI/GetPrvNextInvoiceID?currentID=${currentID}&next=${next}&invoiceType=${invoiceType}`, cacheTypes.NoCache, onGet, "GetPrvNextInvoiceID");
}
export function rewriteAllInvoices(onRewite){
    getMethodByCallBack("api/InvoiceAPI/RewriteInvoices", cacheTypes.NoCache, onRewite, "RewriteInvoices");
}
export function productSerialTurnoverInStorage(data)
{
    return dispatch => dispatch(postMethodByDispatcher("api/InvoiceAPI/ProductSerialTurnoverInStorage", data, "PSERIAL_TURN_IN_STG", "گردش سریال کالاها در انبار"));
}
export function getServiceInvoiceDetailTypes(onGet)
{
    getMethodByCallBack("api/InvoiceAPI/GetServiceInvoiceDetailTypes", cacheTypes.NoCache, onGet, "GetServiceInvoiceDetailTypes");
}
/**
 * 
 * @param {bigint} invoiceID 
 * @param {function} onApprove 
 */
export function approveInvoice(invoiceID, onApprove)
{
    getMethodByCallBack(`api/InvoiceAPI/ApproveInvoice?invoiceID=${invoiceID}`, cacheTypes.NoCache, onApprove, "ApproveInvoice");
}
export function addGuaranteeCardsInvoice(cardIDs, storageID, onAdd)
{
    postMethodByCallBack(`api/InvoiceAPI/AddGuaranteeCardsInvoice?storageID=${storageID}`, cardIDs, onAdd, "AddGuaranteeCardsInvoice");
}
export function updateInvoiceDate(data, onUpdate){
    postMethodByCallBack("api/InvoiceAPI/UpdateInvoiceDate", data, onUpdate, "UpdateInvoiceDate");
}